import { createContext } from 'react';

const ConfirmLogoutModalContext = createContext({
  open: () => {},
});

export default ConfirmLogoutModalContext;
